const SCHEDULE_TIME = {
    MORNING: 'MORNING',
    AFTERNOON: 'AFTERNOON',
    EVENING: 'EVENING',
};

const MORNING_TIME_SLOT = ['09:00', '09:30', '10:00', '10:30', '11:00', '11:30'];
const NOON_TIME_SLOT = ['12:00', '12:30', '13:00', '13:30', '14:30', '14:30', '15:00', '15:30'];
const EVENING_TIME_SLOT = ['16:00', '16:30', '17:00', '17:30', '18:00', '18:30'];

export default SCHEDULE_TIME;
export { MORNING_TIME_SLOT, NOON_TIME_SLOT, EVENING_TIME_SLOT };
